<template>
  <b-card header="Add New Evidence" no-body>
    <b-card class="p-3">
      <div class="row mb-3">
        <div class="col">
          <label class="control-label visible-ie8 visible-ie9" for="course">Unit</label>
          <select :class="{'form-control': true, 'is-invalid': errors.has('course')}"
                  v-validate="'required'"
                  data-vv-delay="500"
                  data-vv-as="Unit"
                  data-vv-name="course"
                  type="text"
                  name="course"
                  id="course"
                  v-model="course_id">
            <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.name }}</option>
          </select>
          <div class="invalid-tooltip d-block" v-if="errors.has('course')">{{ errors.first('course') }}</div>
        </div>
        <div class="col" v-if="course_id">
          <label class="control-label visible-ie8 visible-ie9" for="module">Module</label>
          <select :class="{'form-control': true, 'is-invalid': errors.has('module')}"
                  v-validate="'required'"
                  data-vv-delay="500"
                  data-vv-as="module"
                  data-vv-name="module"
                  type="text"
                  name="module"
                  id="module"
                  v-model="module_id">
            <option v-for="module in selectedCourse.modules" :key="module.id" :value="module.id">{{ module.name }}</option>
          </select>
          <div class="invalid-tooltip d-block" v-if="errors.has('module')">{{ errors.first('module') }}</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label class="control-label visible-ie8 visible-ie9" for="project_name">Project Name</label>
          <input
                  :class="{'form-control': true, 'is-invalid': errors.has('project_name')}"
                  v-validate="'required'"
                  data-vv-delay="500"
                  data-vv-as="Project Name"
                  data-vv-name="project_name"
                  type="text"
                  placeholder="Project Name"
                  name="project_name"
                  id="project_name"
                  v-model="project_name"/>
          <div class="invalid-tooltip d-block" v-if="errors.has('project_name')">{{ errors.first('project_name') }}</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label class="control-label visible-ie8 visible-ie9" for="job_notes">Job Notes</label>
          <vue-editor :class="{'is-invalid': errors.has('job_notes')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Job Notes"
                      data-vv-name="job_notes"
                      type="textarea"
                      placeholder="Job Notes"
                      name="job_notes"
                      id="job_notes"
                      v-model="job_notes"></vue-editor>
          <div class="invalid-tooltip d-block" v-if="errors.has('job_notes')">{{ errors.first('job_notes') }}</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <loading-button :loading="loading" @submit="createGallery" block>Create New Gallery</loading-button>
        </div>
      </div>
    </b-card>
  </b-card>
</template>

<script>
import find from 'lodash-es/find';

export default {
  name: 'EvidenceGallerySubmit',
  data () {
    return {
      loaded: false,
      courses: [],
      course_id: null,
      module_id: null,
      project_name: '',
      job_notes: '',
      loading: false
    };
  },
  methods: {
    getCourses () {
      this.axios.get('/courses', {params: {includes: 'modules'}}).then(rsp => {
        this.courses = rsp.data;
      });
    },
    createGallery () {
      this.$validator.validateAll().then(rsp => {
        if (!rsp) return;

        let params = {
          course_id: this.course_id,
          module_id: this.module_id,
          project_name: this.project_name,
          notes: this.job_notes
        };
        this.loading = true;
        this.axios.post('/evidence_gallery', params).then(rsp => {
          this.$swal('Success', 'Gallery Created', 'success').then(() => {
            this.$router.push('/evidence_gallery/' + rsp.data.data.id);
          });
        }).catch(err => {
          this.$errorOut(err);
          this.loading = false;
        });
      });
    }
  },
  computed: {
    selectedCourse () {
      return find(this.courses, {id: this.course_id});
    }
  },
  mounted () {
    this.getCourses();
  }
};
</script>

<style scoped lang="scss">
  .img-picker {
    width: 80%;
    height: auto;
  }

  .img-picker-box {
    border: #bebebe 1px dashed;
    height: 100%;

    i {
      color: #767676;
    }
  }

</style>